<template>
  <q-dialog
    :visible="isVisible"
    title="编辑"
    width="600px"
    @close="onCancel"
    :innerScroll="false"
    :loading="loadingBtn"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <div class="unable-listing-container">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="120px" label-position="left">
        <el-form-item label="店铺简称" prop="shortName">
          <el-input v-model="form.shortName"></el-input>
        </el-form-item>
        <el-form-item label="新品上架" prop="newArrival" size="mini">
          <el-radio-group v-model="form.newArrival" @input="isNewChange">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="在售品信息处理" prop="onSaleUpdate" size="mini">
          <el-radio-group v-model="form.onSaleUpdate" @input="isNewChange">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="店长" prop="storeManagerIds" size="mini">
          <el-select
            v-model="form.storeManagerIds"
            filterable
            remote
            multiple
            collapse-tags
            clearable
            placeholder="请输入关键词"
            :remote-method="(value) => remoteMethod(value, [], 5)"
            size="mini"
            :loading="loading"
          >
            <el-option v-for="item in userList5" :key="item.userId" :label="`${item.userName}-${item.workNo}`" :value="item.userId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运营负责人" prop="operationUserIds" size="mini">
          <el-select
            v-model="form.operationUserIds"
            filterable
            remote
            multiple
            collapse-tags
            clearable
            placeholder="请输入关键词"
            :remote-method="(value) => remoteMethod(value, [], 1)"
            size="mini"
            :loading="loading"
          >
            <el-option v-for="item in userList1" :key="item.userId" :label="`${item.userName}-${item.workNo}`" :value="item.userId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售前客服组长" prop="beforeSaleUserIds">
          <el-select
            v-model="form.beforeSaleUserIds"
            filterable
            remote
            multiple
            collapse-tags
            clearable
            placeholder="请输入关键词"
            :remote-method="(value) => remoteMethod(value, [], 2)"
            size="mini"
            :loading="loading"
          >
            <el-option v-for="item in userList2" :key="item.userId" :label="`${item.userName}-${item.workNo}`" :value="item.userId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售中客服组长" prop="onSaleUserIds">
          <el-select
            v-model="form.onSaleUserIds"
            filterable
            remote
            multiple
            collapse-tags
            clearable
            placeholder="请输入关键词"
            :remote-method="(value) => remoteMethod(value, [], 3)"
            size="mini"
            :loading="loading"
          >
            <el-option v-for="item in userList3" :key="item.userId" :label="`${item.userName}-${item.workNo}`" :value="item.userId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后客服组长" prop="afterSaleUserIds">
          <el-select
            v-model="form.afterSaleUserIds"
            filterable
            remote
            multiple
            collapse-tags
            clearable
            placeholder="请输入关键词"
            :remote-method="(value) => remoteMethod(value, [], 4)"
            size="mini"
            :loading="loading"
          >
            <el-option v-for="item in userList4" :key="item.userId" :label="`${item.userName}-${item.workNo}`" :value="item.userId"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </q-dialog>
</template>

<script>
import axios from '@/utils/axiosInstance';
import { forEach } from 'jszip';
import { fastLerp } from 'zrender/lib/tool/color';
export default {
  name: 'UnableListing',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  // //只有新增值才获取选中列表
  // watch: {
  //   'form.operationUserIds'(newVal, oldVal = []) {
  //     if(newVal.length > oldVal.length) this.init('', newVal, 1)
  //   },
  //   'form.beforeSaleUserIds'(newVal, oldVal = []) {
  //     if(newVal.length > oldVal.length) this.init('', newVal, 2)
  //   },
  //   'form.onSaleUserIds'(newVal, oldVal = []) {
  //     if(newVal.length > oldVal.length) this.init('', newVal, 3)
  //   },
  //   'form.afterSaleUserIds'(newVal, oldVal = []) {
  //     if(newVal.length > oldVal.length) this.init('', newVal, 4)
  //   }
  // },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      changeTye: false,
      form: {
        operationUserIds: [],
        beforeSaleUserIds: [],
        onSaleUserIds: [],
        afterSaleUserIds: [],
        storeManagerIds: [],
        newArrival: '',
        shortName: '',
        onSaleUpdate: ''
      },
      rules: {
        newArrival: [{ required: true, message: '请选择暂缓上架原因', trigger: 'change' }],
        storeManagerIds: [{ required: true, message: '不能为空', trigger: 'change' }],
        operationUserIds: [{ required: true, message: '不能为空', trigger: 'change' }],
        shortName: [{ required: true, message: '不能为空', trigger: 'change' }],
        onSaleUpdate: [{ required: true, message: '不能为空', trigger: 'change' }],
      },
      userList1: [],
      userList2: [],
      userList3: [],
      userList4: [],
      userList5: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [],
        orderList: [],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  async mounted() {
    let { operationUserIds, beforeSaleUserIds, onSaleUserIds, afterSaleUserIds, newArrival, shortName, storeManagerUserIds, onSaleUpdate } = this.rowData;
    this.form.shortName = shortName
    this.form.operationUserIds = operationUserIds ? operationUserIds.split(',') : [];
    this.form.operationUserIds.length && this.remoteMethod('', this.form.operationUserIds, 1);
    this.form.beforeSaleUserIds = beforeSaleUserIds ? beforeSaleUserIds.split(',') : [];
    this.form.beforeSaleUserIds.length && this.remoteMethod('', this.form.beforeSaleUserIds, 2);
    this.form.onSaleUserIds = onSaleUserIds ? onSaleUserIds.split(',') : [];
    this.form.onSaleUserIds.length && this.remoteMethod('', this.form.onSaleUserIds, 3);
    this.form.afterSaleUserIds = afterSaleUserIds ? afterSaleUserIds.split(',') : [];
    this.form.afterSaleUserIds.length && this.remoteMethod('', this.form.afterSaleUserIds, 4);
    this.form.newArrival = newArrival === '是' ? 1 : newArrival == '否' ? 0 : '';
    this.form.onSaleUpdate = onSaleUpdate === '是' ? 1 : onSaleUpdate == '否' ? 0 : '';
    this.form.storeManagerIds = storeManagerUserIds ? storeManagerUserIds.split(',') : [];
    this.form.storeManagerIds.length && this.remoteMethod('', this.form.storeManagerIds, 5);
    this.isNewChange(this.form.newArrival)
  },
  methods: {
    remoteMethod(query, ids, index) {
      let prop = ['operationUserIds', 'beforeSaleUserIds', 'onSaleUserIds', 'afterSaleUserIds', 'storeManagerIds']
      if(this.changeTye) return
      ids = !query ? this.form[prop[index-1]] || [] : [];
      this.loading = true;
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = 'searchUserInfoByName';
      currencyForm.pageSize = 100;
      currencyForm.param = {
        userName: query,
        userId: ids || [],
      };
      axios.post(`/ec-pc-api/custom/reports/data/searchUserInfoByName`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.loading = false;
          this[`userList${index}`] = res.data.list;
          
        }
      });
    },
    isNewChange(val) {
      if(!val){
        this.rules.operationUserIds[0].required = false
        this.rules.storeManagerIds[0].required = false
        this.$nextTick(() => {
          this.$refs.formRef.clearValidate("operationUserIds");
          this.$refs.formRef.clearValidate("storeManagerIds");
        })
      }else{
        this.rules.operationUserIds[0].required = true;
        this.rules.storeManagerIds[0].required = true;
        this.$nextTick(() => {
          this.$refs.formRef.clearValidate("operationUserIds");
          this.$refs.formRef.clearValidate("storeManagerIds");
        })
      }
    },
    // init(val, ids, index) {
    //   this.changeTye = true;
    //   setTimeout(() => {
    //     this.changeTye = false;
    //     this.$nextTick((_) => {
    //       this.remoteMethod(val, ids, index);
    //     });
    //   }, 200);
    // },
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;

        this.loadingBtn = true;
        let data = {
          ...this.rowData,
          ...this.form,
        };
        // 调用暂缓上架接口
        this.$q.configurationCenter
          .storeManageSave({ data: data })
          .then((res) => {
            if (res.success) {
              this.$message.success('编辑成功');
              this.$emit('success');
              this.onCancel();
            } else {
              this.$message.error(res.message || '操作失败');
            }
          })
          .finally(() => {
            this.loadingBtn = false;
          });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.unable-listing-container
  padding: 20px

>>> .el-input--mini .el-input__inner, >>> .el-select, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 100% !important;

>>> .el-input
  width 100% !important;

>>> .el-form-item
  margin-bottom 18px !important;
</style>
